export const properties = {
    MEDIA_PATH: 'header/',
    SPECIAL_COLUMN_TYPE : 'directo',
    ARIA_LABEL_BTN_CERRAR: 'cerrar',
    ID_TITULO_PANEL: 'idTituloEnlacePanel'
}